// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___RzvTu","root__inner":"style-module__root__inner___rgM68","root__status":"style-module__root__status___uxxIv","root__avatar":"style-module__root__avatar___YqwQE","root__number":"style-module__root__number___GcBQX","root__link":"style-module__root__link___zR9AO"};
    if(module.hot) {
      // 1697460472187
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  